/**
 * @autogenerated
 *
 * WARNING: This file is automatically generated based on Contentful schema.
 * DO NOT modify this file manually - your changes will be overwritten.
 *
 * To regenerate this file, run: `yarn contentful generate`.
 * To customize the generated code:
 *   - Modify the schema in Contentful and regenerate.
 *   - Override this module in higher-level packages.
 */

import gql from 'graphql-tag';

import {BaseFormBlockCf058Fragment} from '@amblique/contentful/app/contentful/fragments/form-block-cf058/base-form-block-cf058.fragment';
import {EmbedPanelFragment} from '@amblique/contentful/app/contentful/fragments/embed-panel/embed-panel.fragment';
import {SplitHeadingFragment} from '@amblique/contentful/app/contentful/fragments/split-heading/split-heading.fragment';

export const FullFormBlockCf058Fragment = gql`
  ${BaseFormBlockCf058Fragment}
  ${EmbedPanelFragment}
  ${SplitHeadingFragment}

  fragment FullFormBlockCf058Fragment on FormBlockCf058 {
    ...BaseFormBlockCf058Fragment

    form {
      ...EmbedPanelFragment
    }
    heading {
      ...SplitHeadingFragment
    }
  }
`;
